const STORAGE_KEY = 'timeline-navigation-state';

export const saveTimelineNavigationState = (state) => {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    console.warn('无法保存时间线浏览位置:', error);
  }
};

export const readTimelineNavigationState = () => {
  try {
    const value = window.sessionStorage.getItem(STORAGE_KEY);
    if (!value) return null;

    const state = JSON.parse(value);
    return state && typeof state === 'object' ? state : null;
  } catch (error) {
    window.sessionStorage.removeItem(STORAGE_KEY);
    console.warn('无法恢复时间线浏览位置:', error);
    return null;
  }
};

export const clearTimelineNavigationState = () => {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn('无法清除时间线浏览位置:', error);
  }
};
